// This is just an example,
// so you can safely delete all default props below

export default {
  global: {
    CHOOSE_LANGUAGE: 'เลือกภาษา',
    MISTAKE_SMS: 'รหัส OTP ไม่ถูกต้อง',
    MISTAKE_PASSWORD: 'รหัสผ่านไม่ถูกต้อง',
    CLOSE: 'ปิด',
    UPDATE: 'เปลี่ยนแปลง',
    CANCEL: 'ยกเลิก',
    OK: 'ตกลง',
    gender: {
      MALE: 'ชาย',
      FEMALE: 'หญิง',
      OTHERS: 'อื่น ๆ',
    },
    ALERT: 'แจ้งเตือน',
  },
  layouts: {
    MainLayout: {
      LOGIN_OR_SIGN_UP: 'เข้าสู่ระบบ / สมัครสมาชิก',
      MEMBER_AND_COUPON: 'สมาชิก & คูปอง',
      MY_WALLET: 'กระเป๋าของฉัน',
      EDIT_PROFILE: 'แก้ไขโปรไฟล์',
      TAG_DELIVERY: 'สถานะการจัดส่ง',
      CHANGE_PASSWORD: 'เปลี่ยนรหัสผ่าน',
      PRIVACY_POLICY: 'นโยบายความเป็นส่วนตัว',
      TERMS_OF_SERVICE: 'เงื่อนไขการใช้งาน',
      SWITCH_LANGUAGE: 'เปลี่ยนภาษา',
      SIGN_OUT: 'ออกจากระบบ',
      VERSIONS: 'เวอร์ชัน',
      DEVELOP: 'พัฒนาโดย Privage',
    },
  },
  pages: {
    Consents: {
      HEADER: 'ข้อกำหนดและการให้ความยินยอม',
      HINT: 'กรุณาเลือกความยินยอมในการใช้ข้อมูลส่วนบุคคล เพื่อใช้ในกิจกรรมทางการตลาด',
      ALLOWED: 'ยินยอม',
      NOT_ALLOWED: 'ไม่ยินยอม',
      SAVE: 'บันทึก',
      NEXT: 'ถัดไป'
    },
    CampaignDetail: {
      AVAILABLE_UNTIL: 'ใช้ได้ถึง',
      USE_BEFORE: 'ใช้ได้ก่อน',
      CONDITION: 'เงื่อนไข',
      'POINT_{point}_PTS': 'คะแนน {point} คะแนน',
      '{unit}_{point}_PTS': 'ต้องการ{unit} {point} {unit}',
      AVAILABLE_QTY: 'จำนวนที่ใช้ได้',
      MAX_USE: 'ใช้ได้สูงสุด',
      REQUIRED_CONDITION: 'เงื่อนไขที่ต้องมี',
      GET_COUPON: 'รับคูปอง',
      CONFIRM: 'ยืนยัน',
      ARE_YOU_SURE_TO_GET_THIS_COUPON: 'ยืนยันการรับคูปอง?',
      OK: 'ตกลง',
    },
    ChangePassword: {
      CHANGE_PASSWORD: 'เปลี่ยนรหัสผ่าน',
      CURRENT_PASSWORD: 'รหัสผ่านปัจจุบัน',
      NEW_PASSWORD: 'รหัสผ่านใหม่',
      CONFIRM_NEW_PASSWORD: 'ยืนยันรหัสผ่าน',
      CHANGE_PASSWORD_SUCCESS: 'เปลี่ยนรหัสผ่านสำเร็จ',
      CHANGE_PASSWORD_FAIL: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
      CURRENT_PASSWORD_IS_REQUIRED: 'ต้องใส่รหัสผ่านปัจจุบัน',
      NEW_PASSWORD_IS_REQUIRED: 'ต้องใส่รหัสผ่านใหม่',
      NOT_SAME_CURRENT_PASSWORD: 'รหัสผ่านใหม่ต้องไม่ซ้ำกับรหัสผ่านปัจจุบัน',
      PASSWORD_COMFIRMATION_NOT_MATCH:
        'ยืนยันรหัสผ่านต้องเหมือนกับรหัสผ่านใหม่',
    },
    EditProfile: {
      MY_PROFILE: 'โปรไฟล์ของฉัน',
      FIRST_NAME: 'ชื่อ',
      LAST_NAME: 'นามสกุล',
      GENDER: 'เพศ',
      BIRTH_DATE: 'วันเกิด',
      DAY: 'วัน',
      MONTH: 'เดือน',
      YEAR: 'ปี',
      EMAIL_ADDRESS: 'อีเมล์',
      ADDRESS: 'ที่อยู่',
      CITY: 'เมือง/จังหวัด',
      ZIP: 'รหัสไปรษณีย์',
      FIRST_NAME_IS_REQUIRED: 'กรุณาระบุชื่อ',
      LAST_NAME_IS_REQUIRED: 'กรุณาระบุนามสกุล',
      GENDER_IS_REQUIRED: 'กรุณาระบุเพศ',
      EMAIL_IS_REQUIRED: 'กรุณาระบุอีเมล์',
      ADDRESS_IS_REQUIRED: 'กรุณาระบุที่อยู่',
      CITY_IS_REQUIRED: 'กรุณาระบุเมือง/จังหวัด',
      ZIP_IS_REQUIRED: 'กรุณาระบุรหัสไปรษณีย์',
      UPDATE_PROFILE_SUCCESS: 'ปรับปรุงข้อมูลสำเร็จ',
      Others: 'อื่นๆ',
      KEY_YES: 'ใช่',
      KEY_NO: 'ไม่ใช่',
    },
    Error404: {
      // OOPS_NOTHING_HERE: 'ขออภัย...ไม่พบข้อมูล',
      OOPS_NOTHING_HERE: 'ไม่มีรายการ',
      GO_HOME: 'ไปยังหน้าหลัก',
    },
    Member: {
      MEMBER: 'สมาชิก',
      POINT_HISTORY: 'ประวัติคะแนน',
      AVAILABLE_CAMPAIGN: 'เเคมเปญ',
      EARN_POINT: 'ได้รับคะแนน',
      USE_POINT: 'ใช้คะแนนแลก',
      NO_CARD:
        'คุณยังไม่มีบัตรสมาชิก กรุณาติดต่อเพื่อขอรับบัตรสมาชิกจากผู้ดูแลระบบ',
    },
    Wallet: {
      MY_WALLET: 'กระเป๋าของฉัน',
      AVAILABLE_COUPON: 'คูปองที่ใช้ได้',
      EXPIRED_COUPON: 'คูปองที่หมดอายุแล้ว',
    },
    Pdpa: {
      SUBMIT: 'ส่งคำขอด้านข้อมูลส่วนบุคคล',
      HEADING: 'ใช้สิทธิภายใต้ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล',
      SUB_HEADING:
        'ส่งคำขอด้านข้อมูลของคุณผ่านฟอร์มด้านล่าง คำขอของคุณจะถูกส่งไปยังผู้ดูแลด้านข้อมูล',
      REQUIRED: 'กรุณาระบุข้อมูล',
      NAME: 'ชื่อ',
      LAST_NAME: 'นามสกุล',
      EMAIL: 'อีเมล์',
      Claim: 'ความต้องการใช้สิทธิ',
      Claim_DETAIL: 'รายละเอียดของข้อมูล',
      UPLOAD: 'อัปโหลดหลักฐานยืนยันตัวตน',
      SUCCESS: 'ส่งคำขอด้านข้อมูลส่วนบุคคลเสร็จสิ้น',
    },
  },
  components: {
    CampaignItem: {
      DELIVERY_FORM_DETAIL: 'กรุณากรอกข้อมูลเพื่อจัดส่ง',
      AVAILABLE_UNTIL: 'ใช้ได้ถึง',
      USE_BEFORE: 'ใช้ได้ก่อน',
      CONDITIONS: 'เงื่อนไข',
      'POINT_{point}_PTS': 'คะแนน {point} คะแนน',
      '{unit}_{point}_PTS': 'ต้องการ{unit} {point} {unit}',
      AVAILABLE_QTY: 'จำนวนที่ใช้ได้',
      MAX_USE: 'ใช้ได้สูงสุด',
      REQUIRED_CONDITION: 'เงื่อนไขที่ต้องมี',
      GET_COUPON: 'รับคูปอง',
      CONFIRM: 'ยืนยัน',
      ARE_YOU_SURE_TO_GET_THIS_COUPON: 'ยืนยันการรับคูปอง?',
      OK: 'ตกลง',
      UNUSABLE: 'ไม่สามารถใช้ได้',
      ARE_YOU_SURE_TO_USE_THIS_CAMPAIGN: 'คุณแน่ใจที่จะใช้แคมเปญนี้?',
    },
    CouponCountdown: {
      EXPIRED: 'หมดอายุ',
      COPY: 'คัดลอกรหัส',
      YOUR_TELEPHONE: 'หมายเลขโทรศัพท์มือของคุณ',
    },
    CouponItem: {
      USE_BEFORE: 'ใช้ได้ก่อน',
      ISSUED: 'เริ่มใช้งานตั้งแต่',
      ACTIVATE: 'เปิดใช้งาน',
      CONFIRM: 'ยืนยัน',
      COUPON_WILL_BE_EXPIRE_AFTER_ACTIVATE__ARE_YOU_CONFIRM_TO_ACTIVATE_THIS_COUPON:
        'คูปองจะหมดอายุหลังจากเปิดการใช้งาน คุณยืนยันที่จะเปิดการใช้งานคูปองนี้ใช่ไหม?',
      ERROR: 'ผิดพลาด',
      CANNOT_USE_THIS_COUPON__PLEASE_TRY_AGAIN:
        'ไม่สามารถใช้คูปองนี้ได้ กรุณาลองใหม่อีกครั้ง',
    },
    LoginForm: {
      PHONE_NUMBER: 'เบอร์โทรศัพท์',
      PASSWORD: 'รหัสผ่าน',
      PHONE_NUMBER_IS_REQUIRED: 'กรุณาระบุเบอร์โทรศัพท์',
      PASSWORD_IS_REQUIRED: 'กรุณาระบุรหัสผ่าน',
      REQUEST_OTP: 'ขอ OTP',
      OTP_IS_REQUIRED: 'กรุณาระบุ OTP',
      PLEASE_ENTER_YOUR_OTP_RECEIVED_VIA_SMS_BELOW_OTP_IS_VALID_FOR_5_MINUTES:
        'โปรดใส่ OTP ที่ได้รับผ่านทาง SMS (OTP จะใช้ได้ภายใน 5 นาที)',
      SHOW_PASSWORD: 'แสดงรหัสผ่าน',
      OR: 'หรือ',
      TERMS_AND_CONDITIONS: 'เงื่อนไขการใช้งาน {business}',
      PRIVACY_POLICY: 'นโยบายความเป็นส่วนตัว {business}',
      THIS_PHONE_NUMBER_IS_ALREADY_EXISTS_PLEASE_LINK_YOUR_PHONE_NUMBER:
        'เบอร์โทรศัพท์นี้ถูกใช้งานแล้ว. กรุณาเชื่อมต่อเบอร์โทรศัพท์กับบัญชีที่มีอยู่แล้ว',
      PLEASE_ENTER_YOUR_MOBILE_NUMBER_TO_LOGIN:
        'กรุณาใส่หมายเลขเบอร์โทรศัพท์ เพื่อเข้าใช้งาน',
      VERIFY_PHONE_NUMBER: 'ยืนยันเบอร์โทรศัพท์',
      LOGIN: 'เข้าสู่ระบบ',
    },
    MemberCard: {
      YOUR_POINT: 'คะแนนของคุณ',
      'YOUR_{point}': '{point}ของคุณ',
      POINT: 'คะแนน',
      VALUE: 'บาท',
      UP: 'ขึ้นไป',
      MAX_LEVEL: 'คุณถึงเงื่อนไขระดับบัตรสมาชิกสูงสุดแล้ว',
      CARD_PROMOTION: 'การเลื่อนระดับบัตร',
      CARD_ADJUST: 'วันที่ปรับระดับครั้งถัดไป',
      CARD_ADJUST_PERIOD: 'ปรับระดับทุก',
      CARD_ADJUST_PERIOD_MONTH: 'เดือน',
      CARD_ADJUST_PERIOD_YEAR: 'ปี',
      NEED_POINT_OR_VALUE: 'ต้องการ{unit}สะสมอีก',
      EXPIRE_POINT: 'คะแนนที่จะหมดอายุ',
      'EXPIRE_{point}': '{point}ที่จะหมดอายุ',
      NOT_EXPIRE_POINT: 'คะแนนไม่มีวันหมดอายุ',
      MEMBER_NAME: 'ชื่อสมาชิก',
      CARD_ID: 'เลขสมาชิก',
      CARD_TYPE: 'ชนิดบัตรสมาชิก',
      DOWNGRADE_TO: 'ลดระดับเป็น',
      CARD_INFO: 'รายละเอียด',
      CARD_WILL_DOWNGRADE: 'ชนิดบัตรจะปรับเป็น',
      WHEN: 'ในวันที่',
      POINT_HISTORY: 'แสดงประวัติการได้รับคะแนน',
      YEAR_SCORE: 'คุณมี{unit}สะสมในปัจจุบัน',
    },
    RegisterForm: {
      PHONE_NUMBER: 'เบอร์โทรศัพท์',
      FIRST_NAME: 'ชื่อ',
      LAST_NAME: 'นามสกุล',
      NEW_PASSWORD: 'รหัสผ่านใหม่',
      DATE_OF_BIRTH: 'วันเกิด',
      EMAIL_ADDRESS: 'อีเมล์',
      FIRST_NAME_IS_REQUIRED: 'กรุณาระบุชื่อ',
      LAST_NAME_IS_REQUIRED: 'กรุณาระบุนามสกุล',
      PASSWORD_IS_REQUIRED: 'กรุณาระบุรหัสผ่าน',
      GENDER_IS_REQUIRED: 'กรุณาระบุเพศ',
      EMAIL_IS_REQUIRED: 'กรุณาระบุอีเมล์',
      ADDRESS_IS_REQUIRED: 'กรุณาระบุที่อยู่',
      CITY_IS_REQUIRED: 'กรุณาระบุเมือง/จังหวัด',
      ZIP_IS_REQUIRED: 'กรุณาระบุรหัสไปรษณีย์',
      I_HAVE_READ_AND_ACCEPT_THE_TERMS: 'ข้าพเจ้าได้อ่านและยอมรับ',
      TERMS_AND_CONDITIONS: 'เงื่อนไขการใช้งาน {business}',
      I_HAVE_READ_AND_ACCEPT_THE_PRIVACY: 'ข้าพเจ้าได้อ่านและรับทราบ',
      PRIVACY_POLICY: 'นโยบายความเป็นส่วนตัว {business}',
      YOU_MUST_READ_AND_ACCEPT:
        'คุณต้องอ่านและยอมรับเงื่อนไขการใช้งานและนโยบายความเป็นส่วนตัว',
      BY_CLICKING_SIGN_UP_YOU_AGREE_TO_OUR:
        'เมื่อกดปุ่มสมัครสมาชิกถือว่าคุณได้ยอมรับ',
      AND: 'และ',
      VERIFY_ACCOUNT: 'ยืนยันบัญชีใช้งาน',
      SIGN_UP: 'สมัครสมาชิก',
      CONFIRM: 'ยืนยัน',
      BRANCH: 'สาขา',
      SOMETHING_WENT_WRONG: 'ไม่สามารถดำเนินการได้ กรุณาติดต่อเจ้าหน้าที่',
    },
    Delivery: {
      pending: 'กำลังดำเนินการ',
      done: 'จัดส่งของสำเร็จ',
      SUBMIT_DATA_COMPLETE: 'ส่งข้อมูลเพื่อจัดส่งสินค้าสำเร็จ',
    },
    PointHistoryItem: {
      EARN: 'ได้รับ{unit_point}',
      USE: 'ใช้{unit_point}',
      VOID: 'ยกเลิก{unit_point}',
      FORCE_VOID: 'ยกเลิก{unit_point}',
      VOID_USE: 'ยกเลิก{unit_point}',
      BALANCE: '{unit_point}คงเหลือ',
      EXPIRED: '{unit_point}หมดอายุ',
      VOID_EXPIRED: 'ยกเลิก{unit_point}',
    },
  },
  ONLY_LOGIN: 'เฉพาะผู้ใช้งานที่เข้าสู่ระบบ',
  USE_EXPIRE: 'แคมเปญหมดอายุ',
  NOT_START: 'แคมเปญยังไม่เริ่ม',
  NOT_AVAILABLE: 'แคมเปญยังไม่มี',
  ONLY_STAFF: 'ต้องใช้โดยสตาฟ',
  NOT_ACTIVE: 'แคมเปญยังไม่พร้อม',
  NOT_ENOUGH_POINT: '{unit}ไม่เพียงพอ',
  MEMBER_CARD_EXPIRED: 'บัตรสมาชิกหมดอายุ',
  LIMIT_REACH: 'ถึงขีดจำกัด',
  LIMIT_PER_DAY: 'ถึงขีดจำกัดต่อวัน',
  LIMIT_PER_MONTH: 'ถึงขีดจำกัดต่อเดือน',
  LIMIT_PER_YEAR: 'ถึงขีดจำกัดต่อปี',
  LIMIT_PER_CAMPAIGN: 'ถึงขีดจำกัดต่อแคมเปญ',
  COUPON_NOT_AVAILABLE: 'ไม่มีคูปอง',
  CARD_TYPE_NOT_MATCH: 'ประเภทบัตรไม่ตรงกัน',
  ALREADY_USE: 'ใช้งานแล้ว',
  NO_BIRTHDAY_SET: 'ผู้ใช้ไม่ได้ตั้งค่าวันเกิด',
  NOT_BIRTH_MONTH: 'ไม่ใช่เดือนเกิด',
  INVALID_CONFIG: 'การกำหนดค่าไม่ถูกต้อง',
  CONSENT: {
    ACCEPTED: 'ยอมรับล่าสุด',
    BUTTON: {
      REFRESH: 'ย้อนกลับ',
      ACCEPT: 'ยอมรับ',
      DENY: 'ปฎิเสธ',
      READ_MORE: 'อ่านเพิ่มเติม',
    },
    WARN:
      'คุณไม่สามารถใช้งานระบบได้เนื่องจากคุณไม่ยอมรับ ข้อตกลงและเงื่อนไขการใช้งาน หรือ นโยบายความเป็นส่วนตัวล่าสุด',
  },
}
